import "./StripeCardForm.scss"
import React, { PropTypes } from "react"
import { CreateForm, TextInput, Button } from "../../lib"

const schema = {
  email: {
    label: "Email",
    type: "email",
    placeholder: "example@gmail.com",
    size: 16,
  },
  number: {
    label: "Card Number",
    type: "number",
    placeholder: "**** **** **** ****",
    required: true,
    size: 16,
  },
  exp_month: {
    label: "Month",
    type: "number",
    placeholder: "**",
    required: true,
    size: 2,
  },
  exp_year: {
    label: "Year",
    type: "number",
    placeholder: "****",
    required: true,
    size: 2,
  },
  cvc: {
    label: "CVC",
    type: "number",
    placeholder: "***",
    required: true,
    size: 3,
  },
}

const StripeCardForm = ({
  fieldsData,
  handleSubmit,
  isSubmitting,
  error,
  saving,
  savingLabel,
  promptLabel,
  includeEmail,
}) => {
  return (
    <form className="StripeCardForm" onSubmit={handleSubmit}>
      <div className="StripeCardForm_payment">
        {includeEmail && <TextInput {...fieldsData.email} required />}
        <TextInput {...fieldsData.number} />
        <div className="StripeCardForm_inline">
          <TextInput {...fieldsData.exp_month} />
          <TextInput {...fieldsData.exp_year} />
          <TextInput {...fieldsData.cvc} />
        </div>
      </div>
      <div className="StripeCardForm_control">
        {error && <p className="StripeCardForm_error">{error}</p>}
        <Button type="submit" disabled={isSubmitting || saving} large>
          {isSubmitting || saving ? savingLabel : promptLabel}
        </Button>
      </div>
    </form>
  )
}

StripeCardForm.displayName = "StripeCardForm"

StripeCardForm.propTypes = {
  includeEmail: PropTypes.bool,
  savingLabel: PropTypes.string.isRequired,
  promptLabel: PropTypes.string.isRequired,
  saving: PropTypes.bool.isRequired,
  error: PropTypes.string,
}

StripeCardForm.defaultProps = {
  savingLabel: "Saving...",
  promptLabel: "Save",
}

export default CreateForm(StripeCardForm, schema)



// WEBPACK FOOTER //
// ./src/account/billing/StripeCardForm.js